import { SCENARIOS } from './CurrentDocument';


export default SCENARIOS;
